import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { ParentTechnologyPreferenctConstant } from 'src/app/constants/label-constants';
import { ParentTechnologyPreferenceModel } from 'src/app/models/ParentTechnologyPreferenceModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { AddParentTechnologyPreferenceComponent } from '../add-parent-technology-preference/add-parent-technology-preference.component';
import { StatusDialogboxComponent } from '../../status-dialogbox/status-dialogbox.component';
import { DeleteDialogboxComponent } from '../../delete-dialogbox/delete-dialogbox.component';

@Component({
  selector: 'app-parent-technology-preference',
  templateUrl: './parent-technology-preference.component.html',
  styleUrls: ['./parent-technology-preference.component.scss']
})
export class ParentTechnologyPreferenceComponent {
  receiptContent: any = [];
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  showData: boolean = false;
  displayedColumns: string[] = ['rowNumber', 'name', 'active', 'Action'];
  dataSource: MatTableDataSource<ParentTechnologyPreferenceModel> = new MatTableDataSource();
  parentTechnologyPreferenceStatusObj: any = {};
  TechnologyDeleteObj: any = {};
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  ParentTechnologyPreferenceList: any = [];
  CommonConstant: any = [];
  NoRecordFound: any = [];
  ParentTechnologyPreferenceConstant: any = [];
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private EncrDecr: EncrDecrService,
    private toastr: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.ParentTechnologyPreferenceConstant = ParentTechnologyPreferenctConstant;
    this.CommonConstant = CommonConstant
    this.NoRecordFound = NoRecordFound
    this.getParentTechnologyPreferenceList();
    this.sharedService.setData('Parent Technology Preference');
  }

  getParentTechnologyPreferenceList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.ParentTechnologyPreferences.GetParentTechnologyPreferenceList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.ParentTechnologyPreferenceList = response.data
          this.dataSource.data = this.ParentTechnologyPreferenceList;
          if (this.ParentTechnologyPreferenceList.length > 0) {
            TotalRecords = this.ParentTechnologyPreferenceList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  handleImageError(event: any) {
    event.target.src = '../../../assets/img/default_college.png';
    // Replace with the path to your placeholder image
    event.onerror = null;
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getParentTechnologyPreferenceList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getParentTechnologyPreferenceList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getParentTechnologyPreferenceList();
      this.searchClose = true;
    }
  }

  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getParentTechnologyPreferenceList();
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getParentTechnologyPreferenceList();
    this.searchClose = false;
  }

  AddTechnology(technologyPreferenceId: number) {
    const modalRef = this.modalService.open(AddParentTechnologyPreferenceComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.ParentTechnologyPreferenceId = technologyPreferenceId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getParentTechnologyPreferenceList();
      }
    }).catch((error) => {
    });
  }
  
  Deletepopup(technologyPreferenceId: number, name: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.TechnologyDeleteObj = {
      parentTechnlogyPreferenceId: technologyPreferenceId,
      parentTechnlogyPreferencename: name,
      element: 'parent technlogy preference'
    }
    modalRef.componentInstance.TechnologyDeleteObj = this.TechnologyDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getParentTechnologyPreferenceList();
      }
    }).catch((error) => {
    });
  }

  onStatus(technologyPreferenceId: number, name: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.parentTechnologyPreferenceStatusObj = {
      ParentTechnologyPreferenceId: technologyPreferenceId,
      ParentTechnologyPreferenceName: name,
      activeTechnology: active
    }

    modalRef.componentInstance.parentTechnologyPreferenceStatusObj = this.parentTechnologyPreferenceStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.ParentTechnologyPreferenceList.forEach((element: { technologyPreferenceId: number; active: boolean; }) => {
          if (element.technologyPreferenceId == technologyPreferenceId) {
            element.active = active ? false : true
          }
        });
      }
    }).catch((error) => {
    });
  }
}